import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormProvider as Form } from 'react-hook-form';

FormProvider.propTypes = {
  children: PropTypes.node,
  methods: PropTypes.object,
  onSubmit: PropTypes.func,
  className: PropTypes.string,
};

export default function FormProvider({ children, onSubmit, methods, className }) {
  return (
    <Form {...methods}>
      <form onSubmit={onSubmit} className={classNames(className)}>{children}</form>
    </Form>
  );
}
